<template>
    <div class="flex sm:flex-wrap md:flex-no-wrap gap-x-5">

        <div class="sm:w-full md:w-4/12 lg:w-3/12 xl:w-2/12">
            <vs-card class="relative">
            
            <FiscalFilter :showPayments="showPayments"
                @filter="refine"
                class="p-4"/>
            </vs-card>
        </div>

        <div class="sm:w-full md:w-8/12 lg:w-9/12 xl:w-10/12">

            <transition name="appear">
                <div class="vx-row sm:w-full" v-show="showControls">
                    <vs-checkbox v-model="allChecked" 
                        @click="selectAll = allChecked" 
                        class="vx-col">
                        Selecionar tudo
                    </vs-checkbox>
                    <div class="vx-col flex">
                        <vs-button @click="send"
                            :disabled="!hasSelection" type="flat" icon="send">Enviar</vs-button>
                        <vs-button @click="ignore"
                            :disabled="!hasSelection" type="flat" icon="error">Ignorar</vs-button>
                    </div>
                    <div class="vx-col flex">
                        <span class="text-primary font-semibold ml-3"
                            style="align-self: center;">Valor selectionado: </span>
                        &nbsp;
                        <span class="text-primary font-semibold" style="align-self: center;"> {{ selectedValue | currency }}</span>
                    </div>
                </div>
            </transition>

            <vs-tabs position="top" class="tabs-shadow-none" id="profile-tabs" v-model="activeTab" >

                <vs-tab icon-pack="feather" icon="icon-user" label="Pagamentos não enviados">
                    <fiscal-tab :has-elements="pendingBillsPayments.length">
                        <div v-for="(item, i) in pendingBillsPayments" :key="i"
                            class="vx-col mb-4 sm:w-full lg:w-6/12 xl:w-4/12 uwide-width" style="width: 100%">
                            
                            <FiscalBill :item="item" @select="markSeleted" :selectAll="selectAll"/>
                            
                        </div>
                    </fiscal-tab>
                </vs-tab>
                
                <vs-tab icon="cancel_schedule_send" label="Em contingência">
                    <vs-alert active="true" icon-pack="feather" icon="icon-info" class="h-full mb-3" color="#842993">
                        Todas as notas em contingência são reenviadas de duas em duas horas, até que seja processada ou chegue em 4 tentativas.
                    </vs-alert>
                    <fiscal-tab :has-elements="pendingInvoicesDesc.length">
                        <div v-for="(item, i) in pendingInvoicesDesc" :key="i"
                            class="vx-col mb-4 sm:w-full md:w-6/12 xl:w-4/12" style="width: 100%">
                            
                            <FiscalInvoice :invoice="item" @dispose="askForDisposal"/>
                            
                        </div>
                    </fiscal-tab>
                </vs-tab>
                
                <vs-tab icon="send" label="Notas Enviadas">
                    <fiscal-tab :has-elements="sentInvoicesDesc.length">
                        <div v-for="(item, i) in sentInvoicesDesc" :key="i"
                            class="vx-col mb-4 sm:w-full md:w-6/12 xl:w-4/12" style="width: 100%">
                            
                            <FiscalInvoice :invoice="item" :key="item.id"/>
                            
                        </div>
                    </fiscal-tab>
                </vs-tab>

            
                <vs-tab icon="clear" label="Inutilizadas">
                    <vs-alert active="true" icon-pack="feather" icon="icon-info" class="h-full mb-3" color="#6d6af7">
                        Filtro de data aplicado à data de inutilização.
                    </vs-alert>
                    <fiscal-tab :has-elements="disposedInvoicesDesc.length"
                        noElementsText="Sem inutilizações">
                        <div v-for="(item, i) in disposedInvoicesDesc" :key="i"
                            class="vx-col mb-4 sm:w-full md:w-6/12 xl:w-4/12" style="width: 100%">
                            
                            <FiscalInvoice :invoice="item" :key="item.id"/>
                            
                        </div>
                    </fiscal-tab>
                </vs-tab>

                 <vs-tab icon="block" label="Ignoradas">
                    <fiscal-tab :has-elements="ignoredBillPayments.length">
                        <div v-for="(item, i) in ignoredBillPayments" :key="i"
                            class="vx-col mb-4 sm:w-full md:w-6/12 xl:w-4/12" style="width: 100%">
                            
                            <FiscalBill :item="item" readOnly/>
                            
                        </div>
                    </fiscal-tab>
                </vs-tab>
                
            </vs-tabs>
        </div>

        <a-modal v-model="confirmation.show"
            cancel-text="Cancelar" :zIndex="9999999"
            :title="$t('confirmYourIntention')" @ok="confirmation.handler"
        >
            <b>{{ confirmation.reasonText }}</b><br/><br/>
            Observações:
            <a-textarea v-model="confirmation.reason" class="mt-4"
                :auto-size="{ minRows: 3, maxRows: 5 }"/>
        </a-modal>

        <a-modal v-model="nfceOptionsModal.show"
            cancel-text="Cancelar" :zIndex="9999999"
            :ok-button-props="{ props: { disabled: !cpfIsValid || isNameNeeded} }"
            title="Emitir nota(s)" @ok="nfceOptionsModal.handler"
        >
            CPF na nota?
            <div class="md:w-full">
                <vs-input v-model="nfceOptionsModal.cpf"
                    v-mask="'###.###.###-##'"
                    label="Cpf"
                    class="mt-3" style="width: 100%"
                    type="text"/>
                <span class="text-danger text-sm" v-show="!cpfIsValid">Cpf inválido</span>
                <vs-input v-model="nfceOptionsModal.name"
                    :disabled="!nfceOptionsModal.cpf.length"
                    label="Nome"
                    class="mt-3" style="width: 100%"
                    type="text"/>
                <span class="text-danger text-sm" v-show="isNameNeeded">Nome é obrigatório</span>
            </div>

            <vs-divider border-style="dashed" class="pr-4"/>
<!-- 
            <vs-checkbox v-model="nfceOptionsModal.asBackup"
                class="mt-5">
                Emitir em contingência
            </vs-checkbox>

            <a-textarea v-model="nfceOptionsModal.backupReason"
                :disabled="!nfceOptionsModal.asBackup"
                placeholder="Motivo"
                class="mt-4"
            />
            <vs-divider border-style="dashed" class="pr-4"/>
             -->

            <vs-checkbox v-model="nfceOptionsModal.print"
                class="mt-5">
                Imprimir?
            </vs-checkbox>

        </a-modal>
    </div>
</template>

<script>
    import firebase from 'firebase';
    import { httpsCallable } from "@/firebase/functions";
    import Bugsnag from '@bugsnag/js';
    import hash from '../../hash'
    import _misc from '@/assets/utils/misc.js'
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import FiscalBill from './FiscalBill';
    import FiscalInvoice from './FiscalInvoice';
    import FiscalFilter from './FiscalFilter';
    import FiscalTab from './FiscalTab';
    import { mask } from 'vue-the-mask';

    export default {
        components: {
            FiscalBill,
            FiscalInvoice,
            FiscalFilter,
            FiscalTab
        },
        directives : {mask},
        watch: {
            activeTab: {
                async handler (value) {
                    const { tabConfig, filters } = this;
                    const tab = tabConfig[value];
                    this.showPayments = !!tabConfig[value].showPayments;
                    if (!tab || hash(tab.loaded) == hash(this.filters))
                        return;
                    tabConfig[value].loaded = hash(this.filters);
                    await this.$store.dispatch(tab.action, { filters });
                },
                immediate: false // Fiscal Filter emmit event at creation that trigers first get
            }
        },
        data() {
            return {
                firestore : firebase.firestore(),
                activeTab: 0,
                selections: {},
                selectAll: false,
                filters: {
                    paymentTypes: []
                },
                tabConfig: {
                    0: { loaded: false, action: 'fiscal/fetchPayments', showPayments: true },
                    1: { loaded: false, action: 'fiscal/fetchBackupDocuments' },
                    2: { loaded: false, action: 'fiscal/fetchSent' },
                    3: { loaded: false, action: 'fiscal/fetchDisposed' },
                    4: { loaded: false, action: 'fiscal/fetchIgnoredPayments' },
                },
                showPayments: true,
                confirmation: {
                    show: false,
                    handler: () => {},
                    title: 'teste',
                    reasonText: 'CPF na nota',
                    reason: null
                },
                nfceOptionsModal: {
                    show: false,
                    cpf: '',
                    name: '',
                    asBackup: false,
                    backupReason: '',
                    print: true,
                    handler: () => {},
                }
            }
        },
        computed: {
            hasSelection () { return !!Object.values(this.selections).filter(v => v.selected).length; },
            selectedValue () {
                return Object.values(this.selections)
                    .filter(v => v.selected)
                    .reduce((prev, curr) => prev + curr.value, 0);
            },
            allChecked: {
                get () {
                    return !!Object.values(this.selections).length &&
                        Object.values(this.selections).reduce((prev, curr) => prev && curr.selected, true);
                },
                set (v) {
                    this.selectAll = v;
                }
            },
            selectedPaymentsByBill () {
                const billGroup = {};
                Object.values(this.selections)
                    .filter(p => p.selected)
                    .forEach(p => {
                    if (!billGroup[p.billId])
                        billGroup[p.billId] = [];
                    billGroup[p.billId].push(p);
                });
                return billGroup;
            },
            pendingInvoicesDesc () {
                return [ ...this.pendingInvoices ].sort((a, b) =>
                    new Date(b.docFiscal.dhContingencia) - new Date(a.docFiscal.dhContingencia)
                );
            },
            sentInvoicesDesc () {
                 return [ ...this.sentInvoices ].sort((a, b) => b.docFiscal.numeroNota - a.docFiscal.numeroNota);
            },
            disposedInvoicesDesc () {
                return [ ...this.disposedInvoices ].sort((a, b) =>
                    new Date(b.disposedAt.toDate()) - new Date(a.disposedAt.toDate())
                );
            },
            showControls () { return !this.activeTab; },
            cpfIsValid () {
                if (!this.nfceOptionsModal.cpf || !this.nfceOptionsModal.cpf.length)
                    return true;
                return _misc.validateCPF(this.nfceOptionsModal.cpf);
            },
            isNameNeeded () {
                return !!this.nfceOptionsModal.cpf.length && !this.nfceOptionsModal.name.length;
            },
            ...mapState('fiscal', ['moreToFetch', 'busy', 'pendingInvoices', 'sentInvoices', 'disposedInvoices']),
            ...mapGetters('fiscal', ['pendingBillsPayments', 'ignoredBillPayments']),
            ...mapGetters(['getCompanyID'])
        },
        methods: {
            async refine(filters) {
                this.filters = filters;
                const tab = this.tabConfig[this.activeTab];
                this.tabConfig[this.activeTab].loaded = hash(this.filters);
                await this.$store.dispatch(tab.action, { filters, });
            },
            markSeleted (values) {
                this.selections = values ? { ...this.selections, ...values } : {}
            },
            askConfirmationWithReason (message, onOk) {
                this.confirmation.handler = () => {
                    this.confirmation.show = false;
                    this.nfceOptionsModal.reasonText = '';
                    onOk(this.confirmation.reason);
                }
                this.confirmation.reasonText = message;
                this.confirmation.show = true;
            },
            askForCpf (handler) {
                this.nfceOptionsModal.handler = () => {
                    this.nfceOptionsModal.show = false;
                    const { asBackup, backupReason, print } = this.nfceOptionsModal;
                    const opts = { asBackup, backupReason, print }
                    handler({ cpf: this.nfceOptionsModal.cpf, name: this.nfceOptionsModal.name, opts });
                    this.nfceOptionsModal.cpf = '';
                    this.nfceOptionsModal.name = '';
                    this.nfceOptionsModal.asBackup = false;
                    this.nfceOptionsModal.backupReason = '';
                }
                this.nfceOptionsModal.show = true;
            },
            send () {
                this.askForCpf(async ({ cpf, name, opts }) => {
                    try {
                        this.$vs.loading();
                        const results = await Promise.all(
                            Object.entries(this.selectedPaymentsByBill)
                                .map(([billId, payments]) => this.emmitNfce(billId, payments, cpf, name, opts))
                        );
                        const errors = results.filter(reslt => reslt.error);
                        if (errors.length)
                            this.showError(errors[0].error.details || `Erro ao enviar ${errors.length} nota(s).`);
                        else if (results.filter(r => r.pending).length)
                            this.showWarning('Algumas notas não foram transmitidas para a Sefaz, Devido a isto, foram criadas como contingência. Verifique na aba de contingência');
                        else
                            this.showSuccess('Todas as notas foram transmitidas com sucesso.');
                    } catch (err) {
                        this.showError(`Lamentamos o ocorrido, vamos verificar o erro - ${err.message}`);
                    } finally {
                        this.$vs.loading.close();
                    }
                });
            },
            async emmitNfce (billId, payments, cpf, name, opts) {
                try {
                    // Standalone payments should not send any orderId
                    const orderIds = payments.find(p => !p.orderIds || !p.orderIds.length) ? []
                        : payments.reduce((prev, curr) => [ ...prev, ...curr.orderIds ], []);
                    let call = httpsCallable('emmitNfce');
                    const client = cpf && cpf.length ? { cpf, name } : null;
                    const { data } = await call({ companyId : this.getCompanyID, billId, orderIds, client, opts });
                    return { billId, pending: data.pending };
                } catch (error) {
                    Bugsnag.notify(error);
                    return { billId, error };
                } finally {
                    this.markSeleted(null);
                }
            },
            async askForDisposal (invoice) {
                // TODO BLOCK NUMBERS ON DESCRIPTION!
                this.askConfirmationWithReason('Inutilizar a nota fiscal é irreversível.', async (reason) => {
                    try {
                        this.$vs.loading();
                        let disposeInvoice = httpsCallable('disposeInvoice');
                        await disposeInvoice({ companyId: this.getCompanyID, invoiceId: invoice.id, invoiceNumber: invoice.docFiscal.numeroNota, reason: reason });
                        this.showSuccess('Nota inutilizada com sucesso.');
                    } catch (err) {
                        this.showError(`Lamentamos o ocorrido, vamos verificar o erro - ${err.message}`);
                        Bugsnag.notify(err);
                    } finally {
                        this.$vs.loading.close();
                    }
                });
            },
            showError (message) {
                this.$error({
                    zIndex : 999999,
                    title: 'Erro ao enviar nota(s)',
                    content: message
                });
            },
            showWarning (message) {
                this.$warning({
                    zIndex: 99999,
                    title: 'Atenção',
                    content: message
                })
            },
            showSuccess (message) {
                this.$success({
                    zIndex : 9999999,
                    title: 'Sucesso',
                    content: message
                })
            },
            async ignore () {
                this.askConfirmationWithReason('Estes pagametos não vão mais ser exibidos como pendentes e suas notas não serão enviadas.', async (reason) => {
                    try {
                        this.$vs.loading();
                        const batch = this.firestore.batch();
                        Object.values(this.selectedPaymentsByBill)
                            .forEach(paymetsFromBill => {
                                paymetsFromBill.forEach(payment => {
                                    const docRef = this.firestore.collection('payments').doc(payment.id);
                                    batch.update(docRef, { fiscalStatus: 'ignored', reason: reason || 'Sem motivo' });
                                });
                            })
                        await batch.commit();
                    } catch (err) {
                        this.showError(`Lamentamos o ocorrido, vamos verificar o erro - ${err.message}`);
                    } finally {
                        this.$vs.loading.close();
                    }
                });
            },
            ...mapActions('fiscal', ['fetchPayments', 'fetchBackupDocuments']),
            ...mapMutations('fiscal', ['unregisterListeners', 'reset']),
        },
        beforeDestroy () {
            this.unregisterListeners();
            this.reset();
        }
    }
</script>

<style lang="scss" scoped>

@media (min-width: 1900px) {
    .uwide-width {
        width: 25%!important;
    }
}
@media (min-width: 2200px) {
    .uwide-width {
        width: 20%!important;
    }
}
</style>